export default __webpack_public_path__ + "static/media/wasp-wxdai.cbb34128.png";